module.exports = __webpack_public_path__ + "static/media/badge-sheriff.172b05e6.svg";